import { useEffect, useState } from "react";
import { Loader2, XCircle } from "lucide-react";

export default function GoogleOAuthCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const oauthError = params.get("error");

    if (oauthError) {
      setError(`Google OAuth error: ${oauthError}`);
      return;
    }

    if (!code) {
      setError("No authorization code received");
      return;
    }

    // Redirect to native app with the code
    // The app will handle the token exchange (where user is authenticated)
    const appUrl = `flextrack://oauth/google?code=${encodeURIComponent(code)}`;
    window.location.href = appUrl;
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center space-y-4">
          <XCircle className="h-12 w-12 mx-auto text-destructive" />
          <p className="text-lg font-medium">Connection Failed</p>
          <p className="text-sm text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin mx-auto text-primary" />
        <p className="text-lg font-medium">Redirecting to app...</p>
        <p className="text-sm text-muted-foreground">
          You can close this page after the app opens.
        </p>
      </div>
    </div>
  );
}
